import React from 'react';

import IconType from '../../../types/Icon';

const PhoneShake: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.0879 2C13.9449 2 13.7993 2.01864 13.6543 2.05664L5.5957 4.2168C4.7057 4.4558 4.17897 5.36977 4.41797 6.25977L8.30273 20.7637C8.50273 21.5087 9.17611 22 9.91211 22C10.0551 22 10.2007 21.9814 10.3457 21.9434L18.4023 19.7832C19.2923 19.5452 19.82 18.6302 19.582 17.7402L15.6973 3.23633C15.4973 2.49133 14.8239 2 14.0879 2ZM13.8516 4.07422L14.3223 5.83008L6.91406 7.85547L6.43359 6.0625L13.8516 4.07422ZM20.75 5.33789L18.8184 5.85547L20.9766 13.9141L22.9082 13.3965L20.75 5.33789ZM14.8398 7.76367L16.5703 14.2227L9.16211 16.248L7.43164 9.78711L14.8398 7.76367ZM3.02344 10.0879L1.0918 10.6055L3.25 18.6621L5.18164 18.1445L3.02344 10.0879ZM17.0879 16.1562L17.5664 17.9375L10.1484 19.9258L9.67969 18.1797L17.0879 16.1562Z"
				fill={color}
			/>
		</svg>
	);
};

export default PhoneShake;
